import React from 'react';
import { Container } from './Container';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="paper-grain relative bg-shell py-16 sm:py-24" data-id="element-24" data-mp="av370wfflb2q">
      <Container className="relative" data-id="element-25" data-mp="fu69c9411370">
        <SectionHeading id="bonuses-heading" eyebrow="Included today" title="And You’ll Also Get These Bonuses" data-id="element-26" data-mp="fsv9gkdpcfl6" />

        <ul className="mt-12 grid grid-cols-1 gap-5 sm:mt-16 sm:grid-cols-2 lg:grid-cols-3" data-id="element-27" data-mp="5w0do98tctal">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex flex-col overflow-hidden rounded-xl2 border border-hairline bg-white shadow-paper" data-id="element-28" data-mp="3o2n0lp033oew" data-mpi={index}>
              <div className="relative" data-id="element-29" data-mp="1m9qi5h3uhjkr">
                <img src={bonus.image} alt={bonus.alt} loading="lazy" className="aspect-[4/3] w-full object-cover" data-id="element-30" data-mp="1mars1i94k00w" />
                <span className="absolute left-4 top-4 rounded-full bg-flame px-3 py-1.5 font-display text-[10px] font-extrabold uppercase tracking-[0.16em] text-white shadow-paper" data-id="element-31" data-mp="3iclm7offscw8">
                  Free Bonus
                </span>
              </div>

              <div className="flex flex-1 flex-col p-5 sm:p-6" data-id="element-32" data-mp="3n4mwj4t1ntjm">
                <span className="font-display text-[11px] font-semibold uppercase tracking-[0.2em] text-muted" data-id="element-33" data-mp="3n7itapt5oc6h">
                  Bonus #{index + 1}
                </span>
                <h3 className="mt-2.5 font-display text-[19px] font-bold leading-snug tracking-[-0.015em] text-ink" data-id="element-34" data-mp="2ui25k5ghdjgl">
                  {bonus.title}
                </h3>
                <p className="mt-2.5 text-[16px] leading-[1.6] text-muted" data-id="element-35" data-mp="33gw626wxmtzf">{bonus.description}</p>
              </div>
            </li>)}
        </ul>
      </Container>
    </section>;
}